<script lang="ts">
import { defineComponent, reactive } from 'vue'
import BreadcrumbNavigation from '@/components/_core/BreadcrumbNavigation.vue'
import stateInitializer from '@/models/stateInitializer'

export default defineComponent({
  name: 'SolutionBreadcrumb',

  components: {
    BreadcrumbNavigation,
  },

  setup() {
    interface State {
      items: Record<'label' | 'to', string>[],
    }

    const state: State = reactive({
      items: [],
    })

    stateInitializer(state, 'breadcrumb')

    return {
      // data
      state,
    }
  },
})
</script>

<template>
  <BreadcrumbNavigation :items="state.items" />
</template>
